import React from 'react';
import './spinnerStyles.css'

const Spinner = () => {

    return (
        <div className="td-settings-spinner"></div>
    );
}

export default Spinner;
